import {Space, Typography} from "antd";

const {Text} = Typography;

let formatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const DataTotalDisplay = ({currentCount, totalCount}) => (<Space direction="vertical">
  <Text type="secondary">
    Mostrando <Text strong>{!isNaN(currentCount) && formatter.format(currentCount)} registro{currentCount > 1 && "s"}</Text> de un
    <Text type="success" strong> total de {!isNaN(totalCount) && formatter.format(totalCount)}</Text>
  </Text>
</Space>);

export default DataTotalDisplay;